import React from 'react';
import { IconProps } from './type';

const CreditCardIcon = (props: IconProps) => {
  const { w, h } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={`${w ? w : '20'}`}
      height={`${h ? h : '20'}`}
      fill="none"
      viewBox="0 0 20 20">
      <mask
        id="mask0_1423_15153"
        style={{ maskType: 'alpha' }}
        width="20"
        height="20"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse">
        <path fill="#D9D9D9" d="M0 0H20V20H0z"></path>
      </mask>
      <g mask="url(#mask0_1423_15153)">
        <path
          fill="#fff"
          d="M3.33 16.662c-.458 0-.85-.164-1.176-.49a1.605 1.605 0 01-.49-1.177v-10c0-.459.163-.85.49-1.177.326-.327.718-.49 1.177-.49h13.333c.458 0 .85.163 1.177.49.326.326.49.718.49 1.177v10c0 .458-.163.85-.49 1.177-.326.326-.719.49-1.177.49H3.331zm0-6.667h13.334V6.66H3.331v3.334z"></path>
      </g>
    </svg>
  );
};

export default CreditCardIcon;
